///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Directive, ElementRef, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { _isEqual } from '../../utils';
import { isDefined } from '@siklu/sui-lib/utils';

@Directive({
    selector: '[windeBoolToCheckMark]',
    standalone: false
})
export class GtthBooleanToCheckMarkDirective implements OnInit, OnChanges {
    @Input() booleanToConvert: boolean;
    @Input() isDisabled: boolean;

    constructor(private readonly el: ElementRef) {}

    ngOnInit(): void {
        this.setCheckMark();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (
            (changes.booleanToConvert && !_isEqual(changes.booleanToConvert.currentValue, changes.booleanToConvert.previousValue)) ||
            (changes.isDisabled && !_isEqual(changes.isDisabled.currentValue, changes.isDisabled.previousValue))
        ) {
            if (changes.isDisabled && isDefined(changes.isDisabled.currentValue)) {
                this.isDisabled = changes.isDisabled.currentValue;
            }
            if (changes.booleanToConvert && isDefined(changes.booleanToConvert.currentValue)) {
                this.booleanToConvert = changes.booleanToConvert.currentValue;
            }
            this.setCheckMark();
        }
    }

    setCheckMark() {
        let innerHTMLValue: string;

        if (isDefined(this.booleanToConvert) && this.booleanToConvert) {
            innerHTMLValue = '&#10004';
        } else if (this.isDisabled) {
            innerHTMLValue = '&#10006';
        } else {
            innerHTMLValue = '&#10060';
        }

        this.el.nativeElement.innerHTML = innerHTMLValue;
    }
}
